$(document).ready(function () {
    var items    = $('.orders-item .info .show-details');

    items.click(function(){
        var elem = $(this),
            dropdown = elem.parent().next(),
            dropdowns = $('.orders-item .dropdown'),
            index = dropdowns.index(dropdown);
        
        elem.toggleClass('active');
        dropdowns.splice(index, 1);
        dropdowns.stop();
        dropdowns.slideUp(300);
        dropdown.stop();
        dropdown.slideToggle(300);
    })

    $('.mobile-nav-toggler').click(function(){
        var parent = $('.dashboard-nav-mobile');

        parent.toggleClass('show');
        $(document).mouseup(function (e){
            if (!parent.is(e.target) && parent.has(e.target).length === 0) {
                parent.removeClass('show');
            }
        });
    })

    // Проверки на Checkbox'ы
    function checkCheckboxes(){
        var checkboxes  = $('.item-checkbox input').length,
            checked     = $('.item-checkbox input:checked').length,
            check_all   = $('#check-all'),
            btns        = $('.del-all, .req-all');

        if(checked > 0){
            btns.removeClass('grey-disabled').removeAttr('disabled');
        }else{
            btns.addClass('grey-disabled').attr('disabled', true);
        }

        if(checkboxes == checked){
            check_all.prop('checked', true);
        }else{
            check_all.prop('checked', false);
        }  

    }

    // Поставить галочку на все чекбоксы
    $('.check-all input').click(function(){
        var items   = $('.item-checkbox input'),
            checked = $('.item-checkbox input:checked');
        
        if(items.length == checked.length){
            items.prop('checked', false);
        }else{
            items.prop('checked', true);
        }        

        checkCheckboxes();

    })

    var lastChecked = null;
    
    // Запуск проверки чекбоксов
    $(document).on('click', '.item-checkbox input', function(e){
        var elem = $(this);        

        if(!lastChecked) {
            lastChecked = elem;
        }        

        var parent              = $(this).parents('.orders-item'),
            lastCheckedParent   = lastChecked.parents('.orders-item'),
            items               = $('.orders-item'),
            checked             = $('.item-checkbox input:checked'),
            checkboxes          = $('.item-checkbox input'),
            check_all           = $('#check-all'),
            prop                = lastChecked.prop('checked');        

        if(e.shiftKey) {
            var start = items.index(parent),
                end   = items.index(lastCheckedParent),
                range = checkboxes.slice(Math.min(start,end), Math.max(start,end)+ 1),
                check = 0;

            elem.prop('checked', prop);     

            range.each(function(){
                var elem = $(this);
                
                if(elem.prop('checked') != prop){
                    check++;
                }

            })            

            if(check == 0 && range.length > 2){
                range.prop('checked', !prop);
            }else{
                range.prop('checked', prop);
            }

        }

        lastChecked = elem;
        checkCheckboxes();
        
    });  
    
});